<confirm-modal>
    <dialog id="confirm-modal" class="modal" aria-labelledby="confirm-modal-heading">
        <div class="modal-box">
            <button type="button" class="absolute end-2 top-2 cursor-pointer text-xl" aria-label="{locale?.t('close')}" onclick="{handleCancel}">
                <i class="icon-clear"></i>
            </button>
            <h3 id="confirm-modal-heading" class="font-bold text-lg text-primary">{state.title}</h3>
            <p class="py-4">{state.message}</p>
            <div class="modal-action">
                <button class="btn text-primary rounded-lg" aria-label="{locale?.t('cancel')}" onclick="{handleCancel}">{locale?.t('cancel')}</button>
                <button class="btn btn-error rounded-lg" aria-label="{state.confirmText}" onclick="{handleConfirm}">{state.confirmText}</button>
            </div>
        </div>
        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        export default {

            state: {
                title: 'Confirm',
                message: 'Are you sure?',
                confirmText: 'Confirm',
                onConfirm: null
            },

            show(title, message, confirmText = 'Confirm') {
                return new Promise((resolve) => {
                    this.update({
                        title,
                        message,
                        confirmText,
                        onConfirm: resolve
                    })
                    document.getElementById('confirm-modal').showModal()
                })
            },

            handleConfirm() {
                if (this.state.onConfirm) {
                    this.state.onConfirm(true)
                }
                document.getElementById('confirm-modal').close()
            },

            handleCancel() {
                if (this.state.onConfirm) {
                    this.state.onConfirm(false)
                }
                document.getElementById('confirm-modal').close()
            }
        }
    </script>
</confirm-modal>